import Misc from './misc';
import Auth from './auth';
import AWS from './aws';
import Dashboard from './dashboard';
import Events from './events';
import Plugins from './plugins';
import HighLevel from './high-level';

export default {
  Misc,
  Auth,
  AWS,
  Dashboard,
  Events,
  Plugins,
  HighLevel
};



// WEBPACK FOOTER //
// ./src/components/index.js